// removed by extract-text-webpack-plugin
module.exports = {"primaryLink":"_30WGP1bTkDD6T1gGfEozSA","row":"_3GBbmncOwUdHysMBp4gGDe"};


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/components/forms/fieldsets/LinkFieldset.scss
// module id = 1535
// module chunks = 0